/** @format */

import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useEffect, useRef, useState } from "react";

export const ImageContainer = styled("div")(({ theme }) => ({
	position: "relative",
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	width: "100%",
	height: "100%",
	marginTop: "40px",
	marginBottom: "20px",
}));

export const StyledVideo = styled("video")(({ theme }) => ({
	display: "block",
	margin: "0 auto",
	width: "90%",
	height: "83vh",
	objectFit: "cover",
	borderRadius: "20px",
	marginBottom: "95px",

	position: "relative",
	zIndex: 1,
	pointerEvents: "auto",

	[theme.breakpoints.down("md")]: {
		width: "90%",
		height: "auto",
	},

	[theme.breakpoints.down("sm")]: {
		width: "100%",
		height: "auto",
		borderRadius: "20px",
	},
}));

const AppOverViewVideo = () => {
	const videoRef = useRef<HTMLVideoElement>(null);
	const [showUnmute, setShowUnmute] = useState(false);

	useEffect(() => {
		const video = videoRef.current!;

		if (!video) return;

		video.preload = "auto";
		video.muted = true;
		video.playsInline = true;
		video.loop = true;

		video.load();
		video.play().catch(() => {
			/* OK if not in view yet */
		});

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					video.play().catch(() => {});
					setShowUnmute(true);
				} else {
					video.pause();
					setShowUnmute(false);
				}
			},
			{
				root: null,
				rootMargin: "0px 0px -50% 0px",
				threshold: 0,
			}
		);

		observer.observe(video);

		return () => observer.disconnect();
	}, []);

	const handleUnmute = () => {
		const video = videoRef.current;
		if (!video) return;
		video.muted = false;
		setShowUnmute(false);
		video.play().catch(() => {});
	};

	return (
		<Grid container spacing={5} justifyContent="center" alignItems="center">
			<Grid item xs={12} md={12}>
				<ImageContainer>
					<StyledVideo
						ref={videoRef}
						src="https://fundsyfi-videos.s3.us-east-2.amazonaws.com/App-Overview-2.mp4"
						autoPlay
						muted
						loop
						playsInline
						preload="auto"
					/>
					{/* <iframe
						src="https://www.loom.com/embed/83ed9031dc184f89a9da9ddd83e3420e"
						frameBorder="0"
						allowFullScreen
						style={{
							width: "90%",
							height: "83vh",
							borderRadius: "20px",
						}}
					/> */}
					{showUnmute && (
						<button
							onClick={handleUnmute}
							style={{
								position: "absolute",
								top: "50%",
								left: "50%",
								transform: "translate(-50%, -50%)",
								zIndex: 2,
								background: "rgba(255, 255, 255, 0.6)",
								color: "black",
								border: "none",
								borderRadius: "10px",
								padding: "12px 16px",
								cursor: "pointer",
							}}>
							🔊 Tap to un-mute
						</button>
					)}
				</ImageContainer>
			</Grid>
		</Grid>
	);
};

export default AppOverViewVideo;
